import React from 'react'
import { Box } from '@material-ui/core'

export const BonusDisqualifiedBadge = () => {
  return (
    <Box
      display={'flex'}
      width="150px"
      px="4px"
      mx="10px"
      bgcolor="#FFF3CD"
      alignItems="center"
      justifyContent="center"
      borderRadius="8px"
      borderColor="#FFF3CD"
      border="1px solid"
      fontSize="16px"
      color="#000"
    >
      Bonus disqualified
    </Box>
  )
}
